module.exports = __webpack_public_path__ + "img/red-truck.e7671567.png";